<script setup lang="ts">
const { changedParams } = useShop();
</script>

<template>
  <div v-if="changedParams.length" class="flex flex-wrap gap-2">
    <div v-for="(param, i) in changedParams" :key="i" class="inline-flex items-center gap-1 rounded-full bg-primary px-4 py-1 pr-2 text-base leading-none text-white">
      {{ param.label }}
      <span class="i-local-x size-6 cursor-pointer" @click="param.reset()" />
    </div>
  </div>
</template>
